export default __webpack_public_path__ + "static/media/publisher-24.fdd02d71.png";